module.exports = __webpack_public_path__ + "static/media/howitworks_hero.616767fb.png";